import { Injectable } from '@angular/core';
import {
  createIcons,
  Eye,
  Pencil,
  Trash2,
  ChevronsLeft,
  ChevronsRight,
  Scan,
  Download
} from 'lucide';

@Injectable({
  providedIn: 'root',
})
export class LucideService {

  private readonly iconSet = {
    Eye,
    Pencil,
    Trash2,
    ChevronsLeft,
    ChevronsRight,
    Scan,
    Download
  };

  private responsiveListenerAttached = false;

  initIcons(): void {
    this.loadIcons();
    this.attachResponsiveListener();
  }

  refreshIcons(): void {
    this.loadIcons();
  }

  private loadIcons(): void {
    createIcons({
      icons: this.iconSet,
    });
  }

  private attachResponsiveListener(): void {
    if (this.responsiveListenerAttached) return;
    this.responsiveListenerAttached = true;

    const observer = new MutationObserver(() => {
      if (document.querySelector('i[data-lucide]')) {
        this.loadIcons();
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }
}